import {
  GET_SURVEY_TEMPLATES,
  GET_SURVEY_TEMPLATE,
  CREATE_SURVEY_TEMPLATE,
  UPDATE_SURVEY_TEMPLATE,
  DELETE_SURVEY_TEMPLATES,
  CLEAR_SURVEY_TEMPLATE_STORE,
  GETTING_SURVEY_TEMPLATES,
  GETTING_SURVEY_TEMPLATE,
  CREATING_SURVEY_TEMPLATE,
  UPDATING_SURVEY_TEMPLATE,
  DELETING_SURVEY_TEMPLATES,
  GETTING_SURVEY_TEMPLATE_SUCCEEDED,
  CREATING_SURVEY_TEMPLATE_SUCCEEDED,
  UPDATING_SURVEY_TEMPLATE_SUCCEEDED,
  DELETING_SURVEY_TEMPLATES_SUCCEEDED,
  GETTING_SURVEY_TEMPLATES_SUCCEEDED,
  GETTING_SURVEY_TEMPLATES_FAILED,
  GETTING_SURVEY_TEMPLATE_FAILED,
  CREATING_SURVEY_TEMPLATE_FAILED,
  UPDATING_SURVEY_TEMPLATE_FAILED,
  DELETING_SURVEY_TEMPLATES_FAILED,
  SET_NEXT_STEP,
  UNSET_NEXT_STEP,
  SET_CURRENT_SURVEY_TEMPLATE,
  UNSET_CURRENT_SURVEY_TEMPLATE,
  CLEAR_SURVEY_TEMPLATE_ERROR,
  SET_COPY_CURRENT_SURVEY_TEMPLATE,
  TEST_SURVEY_TEMPLATE,
  TESTING_SURVEY_TEMPLATE,
  TESTING_SURVEY_TEMPLATE_SUCCEEDED,
  TESTING_SURVEY_TEMPLATE_FAILED,
  SURVEY_TEMPLATE_AUTO_SAVE_TIMER_START,
  SURVEY_TEMPLATE_AUTO_SAVE_TIMER_END,
  SET_CUSTOMIZED_TEMPLATE,
  UNSET_CUSTOMIZED_TEMPLATE,
  GET_PAGINATED_SURVEY_TEMPLATES,
  GETTING_PAGINATED_SURVEY_TEMPLATES,
  GETTING_PAGINATED_SURVEY_TEMPLATES_SUCCEEDED,
  GETTING_PAGINATED_SURVEY_TEMPLATES_FAILED,
  GET_MINIMAL_SURVEY_TEMPLATES,
  GETTING_MINIMAL_SURVEY_TEMPLATES,
  GETTING_MINIMAL_SURVEY_TEMPLATES_SUCCEEDED,
  GETTING_MINIMAL_SURVEY_TEMPLATES_FAILED,
  GET_SURVEY_TEMPLATE_TAGS,
  GETTING_SURVEY_TEMPLATE_TAGS,
  GETTING_SURVEY_TEMPLATE_TAGS_SUCCEEDED,
  GETTING_SURVEY_TEMPLATE_TAGS_FAILED,
  UPDATE_SURVEY_TEMPLATE_FILTERS,
  RESET_SURVEY_TEMPLATE_FILTERS
} from './actions';
import { createReducer } from '@reduxjs/toolkit';
import starters from './data/templateStarters.json';
import { Base64 } from 'js-base64';
import sortBy from 'lodash.sortby';
import { produce } from 'immer';
import { ProductType } from 'constants.js';

const deCamelizer = str => {
  return str
    .replace(/([A-Z])/g, ' $1')
    .replace(/([0-9]+)/g, ' $1')
    .replace(/^./, str => str.toUpperCase());
};

const initialState = {
  getting: false,
  gettingPaginated: true,
  gettingMinimal: false,
  creating: false,
  creatingPaginated: false,
  updating: false,
  deleting: false,
  deletingPaginated: false,
  list: [],
  paginatedList: [],
  minimalList: [],
  minimalTotalRecords: 0,
  current: {
    productType: ProductType.Product
  },
  starters,
  error: {
    message: null,
    raw: null
  },
  isTesting: false,
  isTestingSucceeded: '',
  isTemplateSaved: false,
  shouldAutoSave: false,
  isAutoSaveTimerRunning: false,
  isAutoSaveSuccess: false,
  isTemplateSaving: false,
  customizedTemplate: {},
  isCustomizedTemplateSet: false,
  filters: {
    searchInput: '',
    displayActive: true,
    sortBy: 'name',
    sortOrder: 'ASC',
    rowsPerPage: 10,
    pageNo: 0,
    totalCount: 0,
    filterTemplates: [],
    filterProductNames: [],
    filterProductCategories: [],
    filterTags: []
  },
  tagList: [],
  gettingTags: false
};

export default createReducer(initialState, {
  [GET_SURVEY_TEMPLATES]: state => {
    state.error = {};
    return state;
  },
  [GET_PAGINATED_SURVEY_TEMPLATES]: state => {
    state.error = {};
    return state;
  },
  [GET_SURVEY_TEMPLATE]: state => {
    state.getting = true;
    return state;
  },
  [CREATE_SURVEY_TEMPLATE]: state => {
    state.isTemplateSaved = false;
    state.isTemplateSaving = true;
    return state;
  },
  [UPDATE_SURVEY_TEMPLATE]: state => {
    state.isTemplateSaved = false;
    state.isTemplateSaving = true;
    return state;
  },
  [DELETE_SURVEY_TEMPLATES]: (state, action) => {
    return state;
  },
  [CLEAR_SURVEY_TEMPLATE_STORE]: state => {
    let updatedState = {
      ...initialState
    };
    return updatedState;
  },
  [GETTING_SURVEY_TEMPLATES]: state => {
    state.getting = true;
    state.isCustomizedTemplateSet = false;
    return state;
  },
  [GETTING_PAGINATED_SURVEY_TEMPLATES]: state => {
    state.gettingPaginated = true;
    state.isCustomizedTemplateSet = false;
    return state;
  },
  [GETTING_MINIMAL_SURVEY_TEMPLATES]: state => {
    state.gettingMinimal = true;
    return state;
  },
  [GETTING_SURVEY_TEMPLATE]: state => {
    state.getting = true;
    state.isCustomizedTemplateSet = false;
    return state;
  },
  [CREATING_SURVEY_TEMPLATE]: state => {
    state.creating = true;
    state.current = {
      ...state.current,
      active: state.current.active === undefined ? true : state.current.active
    };
    return state;
  },
  [UPDATING_SURVEY_TEMPLATE]: state => {
    state.updating = true;
    return state;
  },
  [DELETING_SURVEY_TEMPLATES]: state => {
    state.deleting = true;
    return state;
  },
  [GETTING_SURVEY_TEMPLATE_SUCCEEDED]: (state, action) => {
    const { template, eventMetaData = [] } = action.payload;
    function getDisplayName(a) {
      return !a.displayName || a.displayName === ''
        ? deCamelizer(a.conditionAttribute)
        : a.displayName;
    }
    let hydratedEventMetaData = sortBy(
            eventMetaData.map(data => ({
              ...data,
              productName: (data.fieldFromSchema || data.schemaType === "EVENT")
                ? `Event Product - ${template.productName}`
                : ((data.fieldFromSchemaEnrichment || data.schemaType === "ENRICHMENT")
                  ? `Enrichment Product - ${data.enrichmentProduct}`
                  : data.schemaTypeDisplayName
                ),
              schemaConditionAttributes: data.schemaConditionAttributes.map(
                a => ({
                  key: a.conditionAttribute,
                  name: getDisplayName(a),
                  dataType: a.conditionAttributeType,
                  text: `{{${a.conditionAttribute}}}`,
                  attributeFieldType: a.attributeFieldType,
                  hasNestedDataFrame: a.hasNestedDataFrame,
                  metaAttribute: a.metaAttribute,
                  description: a.description,
                  subAttribute: {
                    ...a?.subAttribute,
                    attributes:
                      a?.subAttribute?.attributes &&
                      a.subAttribute['attributes'].map(b => ({
                        key: b.conditionAttribute,
                        name:
                          !b.displayName || b.displayName === ''
                            ? deCamelizer(b.conditionAttribute)
                            : b.displayName,
                        dataType: b.conditionAttributeType,
                        text: `{{${b.conditionAttribute}}}`,
                        metaAttribute: b.metaAttribute,
                        description: b.description
                      }))
                  }
                })
              )
            })).filter(data => data.schemaType === 'EVENT' || data.schemaType === 'ENRICHMENT' || data.schemaType === 'LIST'),
            'name'
          );

    let updatedTemplate = produce(template, templateDraft => {
      templateDraft.eventMetaData = hydratedEventMetaData;
    });

    state.getting = false;
    state.creating = false;
    state.updating = false;
    state.current = { ...updatedTemplate };
    return state;
  },
  [CREATING_SURVEY_TEMPLATE_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.updating = false;
    state.current = { ...action.payload };
    state.isAutoSaveSuccess = state.shouldAutoSave ? true : false;
    state.isTemplateSaved = true;
    state.shouldAutoSave = false;
    state.isTemplateSaving = false;
    return state;
  },
  [UPDATING_SURVEY_TEMPLATE_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.updating = false;
    state.current = { ...action.payload };
    state.isAutoSaveSuccess = state.shouldAutoSave ? true : false;
    state.isTemplateSaved = true;
    state.shouldAutoSave = false;
    state.isTemplateSaving = false;
    return state;
  },
  [DELETING_SURVEY_TEMPLATES_SUCCEEDED]: (state, action) => {
    state.deletingPaginated = false;
    state.current = action.payload.find(uuid => uuid === state.current?.uuid) || {};
    state.paginatedList = state.paginatedList.map(template => {
      if (template.uuid === action.payload[0]) {
        template.active = !template.active;
      }
      return template;
    });
    return state;
  },
  [GETTING_SURVEY_TEMPLATES_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.list = action.payload.map(template => ({
      ...template
    }));
    return state;
  },
  [GETTING_PAGINATED_SURVEY_TEMPLATES_SUCCEEDED]: (state, action) => {
    state.gettingPaginated = false;
    state.paginatedList = action.payload.map(template => ({
      ...template
    }));
    return state;
  },
  [GETTING_MINIMAL_SURVEY_TEMPLATES_SUCCEEDED]: (state, action) => {
    state.gettingMinimal = false;
    state.minimalList = action.payload.data || [];
    state.minimalTotalRecords = action.payload.totalRecords || 0;
    return state;
  },
  [GETTING_SURVEY_TEMPLATES_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GETTING_PAGINATED_SURVEY_TEMPLATES_FAILED]: (state, action) => {
    state.gettingPaginated = false;
    state.creatingPaginated = false;
    state.deletingPaginated = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GETTING_MINIMAL_SURVEY_TEMPLATES_FAILED]: (state, action) => {
    state.gettingMinimal = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GETTING_SURVEY_TEMPLATE_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [CREATING_SURVEY_TEMPLATE_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.isTemplateSaved = false;
    state.shouldAutoSave = false;
    state.isAutoSaveSuccess = false;
    state.isTemplateSaving = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [UPDATING_SURVEY_TEMPLATE_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.isTemplateSaved = false;
    state.shouldAutoSave = false;
    state.isAutoSaveSuccess = false;
    state.isTemplateSaving = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [DELETING_SURVEY_TEMPLATES_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [SET_NEXT_STEP]: state => {
    state.isInTemplateDesignDialog = true;
    return state;
  },
  [UNSET_NEXT_STEP]: state => {
    state.isInTemplateDesignDialog = false;
    return state;
  },
  [SET_CURRENT_SURVEY_TEMPLATE]: (state, action) => {
    state.current = {
      ...action.payload,

      jsonContent:
        action.payload.type === 'EMAIL' &&
        action.payload.layout &&
        !action.payload.jsonContent
          ? JSON.parse(
              Base64.decode(
                starters.find(s => s.id === action.payload.layout).data
              )
            )
          : action.payload.jsonContent
    };
    state.isTemplateSaved = false;
    state.isAutoSaveSuccess = false;
    return state;
  },
  [UNSET_CURRENT_SURVEY_TEMPLATE]: state => {
    state.current = { ...initialState.current };
    return state;
  },
  [CLEAR_SURVEY_TEMPLATE_ERROR]: state => {
    state.error = { ...initialState.error };
    return state;
  },
  [SET_COPY_CURRENT_SURVEY_TEMPLATE]: (state, action) => {
    state.current = action.payload;
    return state;
  },

  [TEST_SURVEY_TEMPLATE]: state => {
    return state;
  },

  [TESTING_SURVEY_TEMPLATE]: state => {
    state.isTesting = true;
    return state;
  },

  [TESTING_SURVEY_TEMPLATE_SUCCEEDED]: state => {
    state.isTesting = false;
    state.isTestingSucceeded = true;
    return state;
  },
  [TESTING_SURVEY_TEMPLATE_FAILED]: state => {
    state.isTesting = false;
    state.isTestingSucceeded = false;
    return state;
  },
  [SURVEY_TEMPLATE_AUTO_SAVE_TIMER_START]: state => {
    state.shouldAutoSave = false;
    state.isAutoSaveSuccess = false;
    state.isAutoSaveTimerRunning = true;
    return state;
  },
  [SURVEY_TEMPLATE_AUTO_SAVE_TIMER_END]: state => {
    state.shouldAutoSave = true;
    state.isAutoSaveTimerRunning = false;
    return state;
  },
  [SET_CUSTOMIZED_TEMPLATE]: (state, action) => {
    state.customizedTemplate = {
      ...action.payload,
      content: !action.payload.jsonContent
        ? state.current.content
        : action.payload.jsonContent.html
    };
    state.isCustomizedTemplateSet = true;
    return state;
  },
  [UNSET_CUSTOMIZED_TEMPLATE]: state => {
    state.customizedTemplate = { ...state.current };
    state.isCustomizedTemplateSet = false;
    return state;
  },

  [GET_SURVEY_TEMPLATE_TAGS]: state => {
    state.error = {};
    return state;
  },

  [GETTING_SURVEY_TEMPLATE_TAGS]: state => {
    state.gettingTags = true;
    return state;
  },

  [GETTING_SURVEY_TEMPLATE_TAGS_SUCCEEDED]: (state, action) => {
    state.gettingTags = false;
    state.tagList = action.payload;
    return state;
  },

  [GETTING_SURVEY_TEMPLATE_TAGS_FAILED]: (state, action) => {
    state.gettingTags = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },

  [UPDATE_SURVEY_TEMPLATE_FILTERS]: (state, action) => {
    state.gettingPaginated = true;
    state.filters = {
      ...state.filters,
      ...action.payload
    };
    return state;
  },

  [RESET_SURVEY_TEMPLATE_FILTERS]: state => {
    state.gettingPaginated = true;
    state.filters = { ...initialState.filters };
    return state;
  }
});
